import { ObjectDrawerFilter } from './object-drawer-filter/object-drawer-filter';

export class ObjectDrawerParameters {
  public parentTreeNodeId: string;
  public searchText: string;
  public filters: ObjectDrawerFilter[] = [];
  public skip: number;
  public take: number;
  public selectedId?: string;
  public useRealTimePermissions: boolean = false;
}
